import {APP_INITIALIZER, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';

import {ConfigLoaderService} from './config-loader.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [
    ConfigLoaderService,
    {
      provide: APP_INITIALIZER,
      useFactory: configLoaderServiceFactory,
      deps: [
        ConfigLoaderService
      ],
      multi: true
    },
  ]
})
export class AppLoaderModule { }


export function configLoaderServiceFactory(configLoaderService: ConfigLoaderService) {
  return () => configLoaderService.loadPlatformConfig();
}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/app-loader/app-loader.module.ts